var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHeaderSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    fill: "black",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7566 12.6488C15.7566 14.5711 14.2178 16.1151 12.3371 16.1151C10.4564 16.1151 8.91754 14.5711 8.91754 12.6488C8.91754 10.7266 10.4564 9.18262 12.3371 9.18262C14.2178 9.18262 15.7566 10.7266 15.7566 12.6488Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4493 17.4673C17.7793 17.7176 18.2469 17.6508 18.4937 17.3181C18.7404 16.9855 18.6729 16.5128 18.3429 16.2626L17.4493 17.4673ZM14.6696 15.3592L17.4493 17.4673L18.3429 16.2626L15.5632 14.1544L14.6696 15.3592Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeaderSearch);
export default __webpack_public_path__ + "static/media/icon-header-search.a87b8859b403413cb72779bbeb677ed2.svg";
export { ForwardRef as ReactComponent };